export default __webpack_public_path__ + "static/Museo-Sans-500-20a14e3358dbb63f77a07b74b5f7854c.woff";